define('viewmodels/notsupportedbrowser',['modulesInitializer'], function (modulesInitializer) {

    return {
        activate: function () {
            return modulesInitializer.init();
        }
    };
});
